













































import { computed, defineComponent, ref, useFetch, useRoute } from '@nuxtjs/composition-api';
import { SfLink } from '@storefront-ui/vue';
import HTMLContent from '~/components/HTMLContent.vue';
import { useApi } from '~/composables';
import ClinicsGoogleMaps from '../components/ClinicsGoogleMaps.vue';
import clinicFullDetailsGql from '../queries/clinicFullDetails.gql';
import { Clinic, ClinicsQuery } from '../types';

export default defineComponent({
  name: 'LabPage',
  components: { ClinicsGoogleMaps, SfLink, HTMLContent },
  setup() {
    const { query } = useApi();
    const route = useRoute();
    const clinic = ref<Clinic | null>(null);

    const mapOptions = computed(() => ({
      center: {
        lat: Number(clinic.value?.latitude) || 59.3293,
        lng: Number(clinic.value?.longitude) || 18.0686,
      },
      zoom: 10,
    }));

    useFetch(async () => {
      const { data } = await query<ClinicsQuery>(clinicFullDetailsGql, { url: route.value.params.slug });
      clinic.value = data.clinics?.items?.[0];
    });

    return {
      clinic,
      mapOptions,
    };
  },
});
